<div class="hx-jodit-editor__wrapper">
  <!-- Main editor container: must be textarea so editHTMLDocumentMode works (Jodit requirement) -->
  <textarea
    #editorContainer
    class="hx-jodit-editor__editor"
    [attr.aria-label]="ariaLabel()"
    [attr.title]="title()"
    [class]="getEffectiveClasses()"
    [style]="getEffectiveStyle()"></textarea>
</div>
